import styled from 'styled-components';
import { animated } from 'react-spring';
import { dfdDefaultTheme, MuiBox } from 'theme/material-ui';
import { headerHeight } from 'components/AuthLayout/styled';

export const SnackContainer = animated(MuiBox);

export const SnacksContainer = styled(MuiBox)`
  display: flex;
  flex-direction: column;
  height: auto;
  width: auto;
  max-height: 100%;
  max-width: 100%;
  position: absolute;
  z-index: ${dfdDefaultTheme.zIndex.snackbar};
  top: ${dfdDefaultTheme.spacing(2) + headerHeight}px;
  right: ${dfdDefaultTheme.spacing(2)}px;
`;
